import React from "react";
import PropTypes from "prop-types";
import ContainerDimensions from "react-container-dimensions";
import { Row } from "react-flexbox-grid/lib/index";
import {
  Button,
  Card,
  CardHeader,
  CardContent,
  CardActions,
  LinearProgress
} from "@material-ui/core";
import Refresh from "@material-ui/icons/Refresh";

import FilesListTable from "./FilesListTable";

const FilesListCard = props => (
  <Card>
    <CardHeader title="Select files to annotate" />
    <CardContent>
      {props.filesFetching && <LinearProgress />}
      <Row center="xs">
        <ContainerDimensions>
          <FilesListTable {...props} />
        </ContainerDimensions>
      </Row>
    </CardContent>
    <CardActions>
      <Button
        variant="text"
        onClick={props.onFilesRefreshClick}
        color="secondary"
        style={{ paddingTop: "10px", marginLeft: "auto" }}
      >
        Refresh
        <Refresh />
      </Button>
    </CardActions>
  </Card>
);

FilesListCard.propTypes = {
  onFilesRefreshClick: PropTypes.func.isRequired
};

export default FilesListCard;
